import React from 'react';
import { Link } from 'react-router-dom';
import '../../App.css';
import './cadastro.css';

export default function Cadastro() {
    return <>
        <body className="cadastro">
        <div class="center">
            <Link to='/cadastro-cachorro'>
                <button className='btn--enviar'>Cachorro</button>
            </Link>
        </div>
        <div class="center">
            <Link to='/cadastro-gato'>
                <button className='btn--enviar'>Gato</button>
            </Link>
            </div>
        </body>
    </>

}